import { useContext } from 'react';

import { FormDetailsPageContext } from '@/components/form-details-page-provider';

function useFormDetailsPage() {
	const context = useContext(FormDetailsPageContext);

	return context;
}

export default useFormDetailsPage;
